/**
 * Questions dépliables.
 *
 * <details> natif plutôt qu'un état React : il fonctionne sans JavaScript,
 * reste accessible au clavier et aux lecteurs d'écran sans une ligne d'ARIA,
 * et le navigateur sait le rechercher avec Ctrl+F même replié.
 */
const FaqBloc = ({ bloc }) => {
    const questions = Array.isArray(bloc?.questions) ? bloc.questions : [];
    if (questions.length === 0) return null;

    return (
        <section className="mb-10" data-testid="bloc-faq">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-5">{bloc.titre}</h2>
            )}
            <div className="space-y-2">
                {questions.map((q, i) => (
                    <details key={i} className="group rounded-xl border border-gray-200 bg-white">
                        <summary className="cursor-pointer list-none px-4 py-3 font-medium text-gray-900 flex items-center justify-between gap-3">
                            <span>{q.question}</span>
                            <span className="text-gray-400 transition-transform group-open:rotate-45">+</span>
                        </summary>
                        {q.reponse && (
                            <div className="px-4 pb-4 text-sm text-gray-600">{q.reponse}</div>
                        )}
                    </details>
                ))}
            </div>
        </section>
    );
};

export default FaqBloc;
